
const mutations = {
  UNIVERSITIES (state, data) {
    state.universities = data
  },
  UNIVERSITY (state, data) {
    state.university = data
  },
  MERCADILLO (state, data) {
    state.mercadillo = data
  },
  BANNERS (state, data) {
    state.banners = data
  }
}

export default mutations
